import {
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import {
  BusinessCenter,
  ChromeReaderMode,
  DynamicFeed,
  LockOpenOutlined,
  People
} from '@material-ui/icons'
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'
import React from 'react'
import { FaTasks } from 'react-icons/fa'
import { GoPackage } from 'react-icons/go'
import { useHistory } from 'react-router-dom'
import UBox from 'src/components/ui/Ubox'
import { SynRoutes } from 'src/core/consts/synRoutes'
import useAtividade from 'src/hooks/useAtividade'
function menuLateral(props) {
  const history = useHistory()
  const { obterQtdePendente } = useAtividade()

  return (
    <List>
      <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemMedicos)}
        id="submenus-medicos"
      >
        <ListItemIcon>
          <People />
        </ListItemIcon>
        <ListItemText primary="Médicos" />
      </ListItem>

      {/* <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemPacotesOperacional)}
      >
        <ListItemIcon style={{ fontSize: '1.4rem' }}>
          <GoPackage />
        </ListItemIcon>
        <ListItemText primary="Pacotes" />
      </ListItem> */}

      <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemOrcamentosOperacional)}
        id="submenus-solicitacoes"
      >
        <ListItemIcon>
          <AssignmentOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Solicitações" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemParceirosOperacional)}
        id="submenus-parceiros"
      >
        <ListItemIcon>
          <BusinessCenter />
        </ListItemIcon>
        <ListItemText primary="Parceiros" />
      </ListItem>

      {/* <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemFinanciamentos)}
        id="submenus-financiamentos"
      >
        <ListItemIcon>
          <ChromeReaderMode />
        </ListItemIcon>
        <ListItemText primary="Financiamentos" />
      </ListItem> */}
      <ListItem
        button
        onClick={() => history.push(SynRoutes.historicoAtualizacoes)}
        id="submenus-atualizacoes"
      >
        <ListItemIcon>
          <DynamicFeed />
        </ListItemIcon>
        <ListItemText primary="Atualizações" />
      </ListItem>

      {/* <ListItem button onClick={() => history.push(SynRoutes.resetSenha)}>
        <ListItemIcon>
          <LockOpenOutlined />
        </ListItemIcon>
        <ListItemText primary="Resetar senha" />
      </ListItem> */}

      <ListItem
        button
        onClick={() => history.push(SynRoutes.tarefas)}
        id="submenus-atividades"
      >
        <ListItemIcon style={{ fontSize: '1.3rem' }}>
          {/* <FcTodoList /> */}
          <FaTasks />
        </ListItemIcon>
        <ListItemText
          primary={
            <UBox>
              Atividades{' '}
              {obterQtdePendente() > 0 && (
                <Chip
                  variant="default"
                  color="secondary"
                  size="small"
                  label={obterQtdePendente()}
                />
              )}
            </UBox>
          }
        />
      </ListItem>

      <ListItem
        button
        onClick={() => window.open('https://syndesk.synsaude.com.br/', '_blank', 'noopener,noreferrer')}
        id="submenus-syndesk"
      >
        <ListItemIcon>
          <ChromeReaderMode />
        </ListItemIcon>
        <ListItemText primary="Syndesk" />
      </ListItem>
    </List>
  )
}

export default menuLateral
